import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { fmtNOK } from "@/lib/format";

export function ProductPicker({ open, onOpenChange, onPick, title = "Add product" }) {
  const [q, setQ] = useState("");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    setLoading(true);
    const t = setTimeout(() => {
      api.get("/products", { params: { q } }).then((r) => setProducts(r.data)).finally(() => setLoading(false));
    }, 150);
    return () => clearTimeout(t);
  }, [q, open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex max-h-[80vh] flex-col gap-3 sm:max-w-2xl" data-testid="product-picker">
        <DialogHeader><DialogTitle>{title}</DialogTitle><DialogDescription>Search the product and service register. Demo prices.</DialogDescription></DialogHeader>
        <div className="relative">
          <Search className="absolute left-3 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name, SKU, manufacturer or tag..." className="h-9 rounded-[10px] pl-9" data-testid="product-picker-search" />
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto rounded-xl border scrollbar-thin">
          {loading && products.length === 0 ? <div className="p-4 text-sm text-muted-foreground">Loading...</div> : products.length === 0 ? <div className="p-4 text-sm text-muted-foreground">No products match.</div> : (
            <ul className="divide-y">
              {products.map((p) => (
                <li key={p.id}>
                  <button type="button" onClick={() => onPick(p)} data-testid={`product-picker-item-${p.id}`} className="flex w-full items-center gap-3 px-3 py-2.5 text-left text-sm hover:bg-muted">
                    <div className="min-w-0 flex-1"><div className="truncate font-medium">{p.name}</div><div className="truncate text-xs text-muted-foreground">{p.manufacturer} · {p.category} · {p.sku}</div></div>
                    <div className="text-right"><div className="tabular font-medium">{fmtNOK(p.list_price)}</div><div className="text-xs text-muted-foreground">per {p.unit} · {p.lead_time_weeks}w</div></div>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
